module.exports = "window.Products.HomeDecor.Coaster = function () {};\nwindow.Products.HomeDecor.Coaster.inherits(window.Products.HomeDecor.HomeDecor);"